import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'
import store from './store/index'
import '@/styles/base.less'
import '@/styles/iconfont.less'
import '@/styles/element-ui.less'
import '@/styles/index.less'
import './permission'
import initApp from '@/utils/app'
import vueTemplate from '@/utils/vueTemplate'
import Copy from 'v-copy'
import { SlideCheck } from 'vue-gn-components';
import emojiRegex from 'emoji-regex';
import echarts from 'echarts'
Vue.prototype.$echarts = echarts

Vue.directive('clearEmoij', {
  bind(el) {
    const regex = emojiRegex();
    const obj = el.querySelectorAll('.el-input__inner,.el-textarea__inner')[0];
    const zclearNoNum = function (e) {
      if (e.target.composing) return;
      const match = regex.exec(obj.value); // 也可以直接用正则表达式判断
      if (match) {
        obj.value = obj.value.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, "");
        zclearNoNum(e);
      }
      // 触发v-model的更新
      obj.dispatchEvent(new Event('input'));
    }
    const zblur = function (e) {
      zclearNoNum(e);
      setTimeout(() => {
        const match = regex.exec(obj.value);
        if (match) {
          obj.value = obj.value.replace(/(\ud83c[\udc00-\udfff])|(\ud83d[\udc00-\udfff])|(\ud83e[\udc00-\udfff])|[\u2100-\u32ff]|[\u0030-\u007f][\u20d0-\u20ff]|[\u0080-\u00ff]/g, "");
          zclearNoNum(e);
        }
        // 触发v-model的更新
        obj.dispatchEvent(new Event('change'));
      }, 50)
    }
    obj.onkeyup = zclearNoNum;
    obj.onblur = zblur;

    function onCompositionStart (e) {
      e.target.composing = true
    }
    function onCompositionEnd (e) {
      e.target.composing = false
      obj.dispatchEvent(new Event('input'));
    }
    obj.addEventListener('compositionstart', onCompositionStart)
    obj.addEventListener('compositionend', onCompositionEnd)
  }
})

Vue.use(SlideCheck)
Vue.use(ElementUI)
Vue.use(vueTemplate)
Vue.use(Copy)

Vue.config.productionTip = false

// app init
initApp(Vue)

new Vue({
  render: h => h(App),
  router,
  store
}).$mount('#app')
